module.exports = __webpack_public_path__ + "media/stylesheets/images/staff_1-3d75ebeccdd0c23e3293a9838a85b9f5.jpg";